var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJupyter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(.54 21.36)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(5.68 21.37)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(13.39 21.26)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_fill",
    transform: "translate(20.43 21.39)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_fill",
    transform: "translate(27.55 19.54)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path5_fill",
    transform: "translate(32.47 21.29)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path6_fill",
    transform: "translate(39.98 21.24)",
    fill: "#4E4E4E",
    style: {
      mixBlendMode: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path7_fill",
    transform: "translate(33.48 .69)",
    fill: "#767677",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8_fill",
    transform: "translate(3.21 31.27)",
    fill: "#F37726",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path9_fill",
    transform: "translate(3.21 4.88)",
    fill: "#F37726",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(3.28 43.09)",
    fill: "#9E9E9E",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_fill",
    transform: "translate(1.87 5.43)",
    fill: "#616262",
    style: {
      mixBlendMode: "normal"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M1.745 5.475c0 1.558-.125 2.066-.445 2.44a1.94 1.94 0 01-1.3.498l.125.89a3.045 3.045 0 002.03-.738 3.561 3.561 0 00.783-2.671V0H1.745V5.475z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M5.502 4.763c0 .668 0 1.264.053 1.78H4.496l-.071-1.059A2.466 2.466 0 012.26 6.695C1.23 6.695 0 6.135 0 3.846V.045h1.193v3.56c0 1.238.383 2.066 1.46 2.066A1.665 1.665 0 004.336 3.99V0h1.193v4.727l-.027.036z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M.053 2.273c0-.828 0-1.505-.053-2.12h1.068l.054 1.114A2.582 2.582 0 013.454.002c1.585 0 2.778 1.327 2.778 3.303 0 2.333-1.433 3.49-2.982 3.49a2.306 2.306 0 01-2.021-1.023v3.56H.053V2.274zM1.23 4.009c.003.161.02.322.053.48a1.834 1.834 0 001.78 1.38c1.256 0 1.995-1.023 1.995-2.51 0-1.3-.695-2.413-1.95-2.413a2.048 2.048 0 00-1.878 1.95v1.113z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M1.318.018L2.75 3.855c.151.427.312.944.418 1.327.125-.392.259-.89.419-1.354l1.3-3.81h1.255l-1.78 4.63c-.89 2.225-1.434 3.374-2.253 4.068a3.24 3.24 0 01-1.46.766l-.294-.997a3.16 3.16 0 001.042-.58 3.561 3.561 0 001.006-1.317.89.89 0 00.098-.285 1.024 1.024 0 00-.08-.311L0 0h1.3l.018.018z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    d: "M2.19 0v1.87H3.9v.89H2.19v3.508c0 .801.232 1.264.89 1.264.234.004.468-.023.695-.08l.053.89c-.34.118-.7.172-1.06.16a1.656 1.656 0 01-1.29-.498 2.395 2.395 0 01-.463-1.692V2.751H0v-.89h1.033V.276L2.19 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5_fill",
    d: "M1.177 3.579A2.092 2.092 0 003.43 5.831a4.345 4.345 0 001.78-.338l.205.89a5.342 5.342 0 01-2.181.401A3.027 3.027 0 01.01 3.508C.01 1.549 1.177 0 3.082 0 5.22 0 5.753 1.87 5.753 3.063c.012.183.012.368 0 .552H1.15l.027-.036zm3.49-.89A1.683 1.683 0 003.011.766a1.968 1.968 0 00-1.825 1.923h3.481z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6_fill",
    d: "M.053 2.192c0-.765 0-1.424-.053-2.03h1.068v1.274h.054A1.968 1.968 0 012.902.01a1.3 1.3 0 01.339 0v1.113a1.78 1.78 0 00-.41 0 1.665 1.665 0 00-1.593 1.513 3.293 3.293 0 00-.054.552v3.464H.01V2.2l.044-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7_fill",
    d: "M6.03 2.836A3.018 3.018 0 112.889.005a2.982 2.982 0 013.143 2.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8_fill",
    d: "M18.696 7.122C10.684 7.122 3.641 4.247 0 0a19.934 19.934 0 0037.392 0C33.76 4.247 26.744 7.122 18.696 7.122z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9_fill",
    d: "M18.696 5.897c8.013 0 15.055 2.876 18.696 7.123A19.934 19.934 0 000 13.02c3.641-4.256 10.648-7.123 18.696-7.123z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10_fill",
    d: "M7.596 3.567A3.802 3.802 0 113.634.005a3.766 3.766 0 013.962 3.562z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11_fill",
    d: "M2.25 4.38A2.19 2.19 0 114.379 2.1a2.217 2.217 0 01-2.127 2.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupyter);
export default __webpack_public_path__ + "static/media/jupyter.098692c15cd8f70ffcf6cbacca506820.svg";
export { ForwardRef as ReactComponent };